import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Zap, MapPin } from 'lucide-react';
import Badge from '../ui/Badge';

// Note: google-map-react wraps this component in its own absolutely-positioned,
// lat/lng-anchored container and measures this element's natural (in-flow) box
// to center it, so the marker itself must stay position:static — the mockup's
// `.smart-marker` utility class bakes in `absolute` positioning for its
// manually-placed fallback map, which we neutralize here with `!static`.
const DashboardIncidentMarker = ({ lat, lng, announcement }) => {
    const [open, setOpen] = useState(false);

    const isDrill = !!announcement?.drill;
    const typeName = announcement?.incident_type?.incident_type_name || (isDrill ? 'Drill' : 'Incident');
    const Icon = isDrill ? Zap : AlertTriangle;

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {!isDrill && announcement?.isMajor && (
                <span className="absolute inset-0 rounded-full bg-red-600/30 animate-ping pointer-events-none" />
            )}

            <Link
                to={`/active-incident/${announcement?.id}`}
                title={announcement?.title}
                className={`smart-marker ${isDrill ? 'drill' : 'incident'} !static !translate-x-0 !translate-y-0`}
            >
                <Icon className="w-[18px] h-[18px]" />
            </Link>

            {open && announcement && (
                <div className="absolute z-30 bottom-full left-1/2 -translate-x-1/2 mb-3 w-64 bg-white border border-neutral-200 rounded-xl shadow-panel overflow-hidden text-left">
                    <div className="p-3 border-b border-neutral-100 flex items-start justify-between gap-2">
                        <div className="min-w-0">
                            <h4 className="text-sm font-bold text-neutral-900 truncate">{announcement.title}</h4>
                            <p className="text-xs text-neutral-500 mt-0.5">
                                {typeName}{announcement.isMajor ? ' • Major' : ''}
                            </p>
                        </div>
                        <Badge variant={isDrill ? 'amber' : 'red'}>{isDrill ? 'Drill' : 'Active'}</Badge>
                    </div>
                    <div className="p-3 text-xs text-neutral-600 space-y-1.5">
                        {announcement.description && (
                            <p className="line-clamp-3">{announcement.description}</p>
                        )}
                        {announcement.location && (
                            <p className="flex items-center gap-1.5 text-neutral-500">
                                <MapPin className="w-3 h-3 shrink-0" />
                                <span className="truncate">{announcement.location}</span>
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardIncidentMarker;
